"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.getConfigValue = void 0;
function getConfigValue(projectName, key) {
    try {
        // eslint-disable-next-line @typescript-eslint/no-explicit-any
        if (!window._cianConfig) {
            return;
        }
        // eslint-disable-next-line @typescript-eslint/no-explicit-any
        var config = window._cianConfig[projectName];
        if (!config) {
            return;
        }
        return searchInConfig(config, key);
    }
    catch (error) {
        console.error(error);
        return;
    }
}
exports.getConfigValue = getConfigValue;
function searchInConfig(config, target) {
    var _a;
    return (_a = config.find(function (_a) {
        var key = _a.key;
        return key === target;
    })) === null || _a === void 0 ? void 0 : _a.value;
}
//# sourceMappingURL=getConfigValue.js.map